import React, { useState } from 'react';
import { ProjectFilterPills } from '../components/ProjectFilterPills';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { ArrowLeft, Search, SlidersHorizontal, FileText, Upload, MoreVertical, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Document {
  id: string;
  name: string;
  folderName: string;
  siteName: string;
  expirationDate: string;
  isExpired: boolean;
}
const MOCK_DOCUMENTS: Document[] = [{
  id: '1',
  name: '417 Carroll DOB Fence Permit Expires 12-3 1-23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '2',
  name: '417 Carroll DOB FO Permit Expires 12-31-2 3',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '3',
  name: '498 Union DOB Temp Power Work Permit',
  folderName: '498 Union',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '4',
  name: '417 DOT PERMIT- B020202329I-A67_ EXP 12-31-23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '5',
  name: '417 DOT PERMIT- B02-202329I-A68 12-31 -23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '6',
  name: '417 DOT PERMIT- B02-202329I-A69 12-31 -23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '7',
  name: '417 DOT PERMIT- B02-202329I-A70 12-31 -23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '8',
  name: '417 DOT PERMIT- B02-202329I-A71 12-31- 23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '9',
  name: '417 DOT PERMIT- B02-202329I-A72 12-31 -23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}, {
  id: '10',
  name: '417 DOT PERMIT- B02-202329I-A73 12-31 -23',
  folderName: '417 Carroll',
  siteName: '300 Nevins',
  expirationDate: '12/31/2023',
  isExpired: true
}];
export function DocumentsPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const {
    selectedProjects
  } = useProjectFilter();
  const activeCount = 125;
  const expiringSoonCount = 33;
  const expiredCount = 72;
  const getProjectDisplayText = () => {
    if (selectedProjects.length === AVAILABLE_PROJECTS.length) {
      return 'All Projects';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Projects`;
  };
  const filteredDocuments = MOCK_DOCUMENTS.filter(doc => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return doc.name.toLowerCase().includes(query) || doc.folderName.toLowerCase().includes(query) || doc.siteName.toLowerCase().includes(query);
  });
  return <div className="min-h-screen bg-[#fafafa] font-sans" data-id="element-4152">
      <main className="p-6 max-w-[1600px] mx-auto pb-24" data-id="element-4153">
        {/* Header with Status Cards */}
        <div className="mb-6" data-id="element-4154">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4 transition-colors" data-id="element-4155">
            <ArrowLeft size={16} data-id="element-4156" />
            Back to Dashboard
          </Link>
          <div className="flex items-start justify-between" data-id="element-4157">
            <div data-id="element-4158">
              <div className="flex items-center gap-2" data-id="element-4159">
                <h1 className="text-3xl font-bold text-gray-900" data-id="element-4160">Documents</h1>
                <span className="text-gray-400 text-2xl" data-id="element-4161">·</span>
                <span className="text-gray-600 text-xl" data-id="element-4162">
                  {getProjectDisplayText()}
                </span>
              </div>
              <ProjectFilterPills data-id="element-4163" />
            </div>

            <div className="flex gap-3" data-id="element-4164">
              <div className="bg-gray-200 rounded-lg px-6 py-3 text-center min-w-[120px]" data-id="element-4165">
                <div className="text-2xl font-bold text-gray-900" data-id="element-4166">
                  {activeCount}
                </div>
                <div className="text-xs font-semibold text-gray-600" data-id="element-4167">
                  Active
                </div>
              </div>
              <div className="bg-amber-100 rounded-lg px-6 py-3 text-center min-w-[120px]" data-id="element-4168">
                <div className="text-2xl font-bold text-amber-700" data-id="element-4169">
                  {expiringSoonCount}
                </div>
                <div className="text-xs font-semibold text-amber-700" data-id="element-4170">
                  Expiring soon
                </div>
              </div>
              <div className="bg-red-100 rounded-lg px-6 py-3 text-center min-w-[120px]" data-id="element-4171">
                <div className="text-2xl font-bold text-red-700" data-id="element-4172">
                  {expiredCount}
                </div>
                <div className="text-xs font-semibold text-red-700" data-id="element-4173">
                  Expired
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results count and controls */}
        <div className="flex items-center justify-between mb-6" data-id="element-4174">
          <div className="text-lg font-medium text-gray-900" data-id="element-4175">
            Found {filteredDocuments.length} documents
          </div>

          <div className="flex items-center gap-3" data-id="element-4176">
            {/* Search */}
            <div className="relative" data-id="element-4177">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-4178" />
              <input type="text" placeholder="Search" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent w-64" data-id="element-4179" />
            </div>

            {/* Upload file button */}
            <button className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors" data-id="element-4180">
              <Upload size={16} data-id="element-4181" />
              Upload file
            </button>

            {/* Filters button */}
            <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-4182">
              <SlidersHorizontal size={16} data-id="element-4183" />
              Filters
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-4184">
          <table className="w-full" data-id="element-4185">
            <thead data-id="element-4186">
              <tr className="border-b border-gray-200 bg-gray-50" data-id="element-4187">
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4188">
                  Name
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4189">
                  Folder Name
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4190">
                  Site Name
                </th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-4191">
                  Expiration Date
                </th>
                <th className="w-12" data-id="element-4192"></th>
              </tr>
            </thead>
            <tbody data-id="element-4193">
              {filteredDocuments.map((doc, index) => <tr key={doc.id} className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/30'}`} data-id="element-4194">
                  <td className="px-6 py-4" data-id="element-4195">
                    <div className="flex items-center gap-3" data-id="element-4196">
                      <div className="flex-shrink-0 w-10 h-10 bg-red-500 rounded flex items-center justify-center" data-id="element-4197">
                        <FileText size={18} className="text-white" data-id="element-4198" />
                      </div>
                      <span className="text-sm text-gray-900 font-medium" data-id="element-4199">
                        {doc.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4200">
                    {doc.folderName}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-900" data-id="element-4201">
                    {doc.siteName}
                  </td>
                  <td className="px-6 py-4" data-id="element-4202">
                    <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-medium" data-id="element-4203">
                      <AlertCircle size={14} data-id="element-4204" />
                      {doc.expirationDate}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-4205">
                    <button className="p-1 hover:bg-gray-200 rounded transition-colors" data-id="element-4206">
                      <MoreVertical size={18} className="text-gray-400" data-id="element-4207" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>

          {filteredDocuments.length === 0 && <div className="text-center py-12" data-id="element-4208">
              <FileText size={48} className="mx-auto text-gray-300 mb-3" data-id="element-4209" />
              <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-4210">
                No documents found
              </h3>
              <p className="text-gray-600" data-id="element-4211">
                Try adjusting your search to find what you're looking for
              </p>
            </div>}
        </div>
      </main>
    </div>;
}